import { useAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { heidi2OnboardingOpenAtom } from '../../../data/heidi-2';

import { heidi2OnboardingLaunchAtom } from '../heidi-2-onboarding-launch-atom';

import type { Heidi2AwarenessBannerPorts } from './heidi-2-awareness-banner-ports';
import { Heidi2OnboardingHost } from './heidi-2-onboarding-host';

/**
 * Mounts the Heidi II tour when something asks to reopen it part-way in — the
 * explore-later banner or the checklist. Separate from the first-run host in
 * `Heidi2AwarenessBanner`, whose audience is still on Heidi 1.
 *
 * Publishes `heidi2OnboardingOpenAtom` while the relaunch is live so Session
 * Merge (and other lower-priority launch surfaces) stay suppressed.
 */
export const Heidi2OnboardingRelaunch = ({
  ports,
}: {
  ports: Heidi2AwarenessBannerPorts;
}) => {
  const [launch, setLaunch] = useAtom(heidi2OnboardingLaunchAtom);
  const setOnboardingOpen = useSetAtom(heidi2OnboardingOpenAtom);

  useEffect(() => {
    if (!launch) return undefined;
    setOnboardingOpen(true);
    return () => setOnboardingOpen(false);
  }, [launch, setOnboardingOpen]);

  if (!launch) return null;

  return (
    <Heidi2OnboardingHost
      ports={ports}
      initialStep={launch.startAt}
      onFinished={() => {
        setLaunch(null);
      }}
    />
  );
};
